<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag
        size="small"
        :type="getTag(scope.row.status).type"
      >
        {{ getTag(scope.row.status).label }}
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
  methods: {
    getTag(status) {
      switch (status) {
        case 'recorded':
          return {
            label: 'Rögzítve',
            type: 'info',
          };
        case 'waiting-for-payee':
          return {
            label: 'Fizetésre vár',
            type: 'primary',
          };
        case 'cancelled':
          return {
            label: 'Érvenytelenítve',
            type: 'danger',
          };
        case 'done':
          return {
            label: 'Teljesítve',
            type: 'success',
          };
        case 'partly-done':
          return {
            label: 'Részben teljesítve',
            type: 'warning',
          };
      }
    },
  },
};
</script>
